import React from 'react';
import { withEditTitle } from '~/platform/forms-system/src/js/web-component-patterns/arrayBuilderPatterns';
import { Title } from 'platform/forms-system/src/js/web-component-patterns';
import { useSelector } from 'react-redux';
import { differenceInYears, isValid, parseISO } from 'date-fns';

export const isRelationshipToVeteran = data => {
  const relationship = data?.claimantRelationship;
  if (relationship === 'SURVIVING_CHILD') {
    return 'child';
  }
  if (relationship === 'SURVIVING_SPOUSE') {
    return 'spouse';
  }
  if (relationship === 'CUSTODIAN_FILING_FOR_CHILD_UNDER_18') {
    return 'custodian';
  }
  return null;
};

export const formatFullName = ({
  first = '',
  middle = '',
  last = '',
  suffix = '',
} = {}) => {
  // ensure that any middle initials are capitalized
  const formattedMiddle = middle
    ? middle.replaceAll(/\b\w\b/g, c => c.toUpperCase())
    : '';
  return [first, formattedMiddle, last, suffix]
    .filter(name => !!name)
    .join(' ')
    .trim();
};

export function getVeteranSpouseDisplayNames({ formData, formContext } = {}) {
  const veteranFullName =
    formContext?.formData?.veteranFullName?.spouseFullName ||
    formData?.veteranFullName;

  const currentSpouseFullName =
    formContext?.formData?.veteranMarriages[formContext?.pagePerItemIndex]
      ?.spouseFullName ||
    formData?.veteranMarriages[formContext?.pagePerItemIndex]?.spouseFullName;

  return {
    veteranName:
      formatFullName(veteranFullName) !== ''
        ? formatFullName(veteranFullName)
        : 'the Veteran',
    spouseName:
      formatFullName(currentSpouseFullName) !== ''
        ? formatFullName(currentSpouseFullName)
        : 'their spouse',
  };
}

export function createVeteranSpousePageTitle({ getTitleText }) {
  return function VeteranSpouseMarriagePageTitle(props) {
    const fullFormData = useSelector(state => state.form?.data);
    const { veteranName, spouseName } = getVeteranSpouseDisplayNames({
      formData: fullFormData,
      formContext: props.formContext,
    });
    const titleText = withEditTitle(getTitleText(veteranName, spouseName))(
      props,
    );

    return (
      <legend className="schemaform-block-title">
        <Title title={titleText} />
      </legend>
    );
  };
}

export const formatDate = dateStr => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-').map(Number);
  const date = new Date(year, month - 1, day); // month is 0-indexed
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  }).format(date);
};

// assumes dob always available from prefill
export const getClaimantAge = data => {
  const dateOfBirth = parseISO(data?.yourDateOfBirth);
  return isValid(dateOfBirth)
    ? differenceInYears(new Date(), dateOfBirth)
    : null;
};

export const isClaimantSchoolAge = data => {
  const age = getClaimantAge(data);
  return age !== null && age >= 18 && age <= 23;
};

export const isClaimant18OrOlder = data => {
  const age = getClaimantAge(data);
  return age !== null && age >= 18;
};
